import React, { useState } from 'react';
import { WebinarData } from '@/config/webinar_config';
import { SEODATA } from '@/config/seo_config';
import ResourcesLinks from '@/layout/resourcesLinks';
import Image from 'next/image';
import Head from 'next/head';
import IMAGES from '@/public/assets/img';


export const metadata = {
  title: SEODATA.WEBINAR.title,
  description: SEODATA.WEBINAR.description,
  keywords: SEODATA.WEBINAR.keyword,
  alternates: {
    canonical: SEODATA.WEBINAR.url
  },
  
  openGraph: {
    title: SEODATA.WEBINAR.title,
    description: SEODATA.WEBINAR.description,
    url: SEODATA.WEBINAR.url,
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
  }
};


export default function Webinar() {
  const [showVideo, setShowVideo] = useState(false);
  const [showVideoLink, setShowVideoLink] = useState('')
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

const showVideoPop=(videoSrc)=>{
  setShowVideo(true)
  setShowVideoLink(videoSrc)
  setIsVideoPlaying(true);
}
const videoOff=()=>{
  setShowVideo(false)
  setShowVideoLink('');
  setIsVideoPlaying(false);
}


  return (
    <main className='mt-[100px]'>
      <Head>  
          <title>{metadata.title}</title>
          <meta name="description" content={metadata.description} />
          <meta name="keywords" content={metadata.keywords} />
          {/* OpenGraph tags */} 
          <meta property="og:title" content={metadata.openGraph.title} />
          <meta property="og:description" content={metadata.openGraph.description} />
          <meta property="og:url" content={metadata.openGraph.url} />
          <meta property="og:image" content={metadata.openGraph.imagePath} />
          <link rel="canonical" href={metadata.alternates.canonical} />
        </Head>
      <section className='py-20 bg-white sm:py-10'>
          <div className='container  lg:px-3 px-3 xm:px-2'>
          <ResourcesLinks />
              <ul className="flex flex-wrap flex-1 -mx-2"> 
                {WebinarData.map((post) => (
                  <li key={post.id} onClick={() => showVideoPop(post.videoLink)} className="w-1/3 md:w-1/2 sm:w-full p-2 list-none">
                    <div className="bg-white shadow-cardShadow2 border border-[#E6E6E6] hover:shadow-cardHover2 transition-shadow animate-fade-in">
                    <div className='cursor-pointer'>
                        <Image className='w-full h-[193px]' priority
                          src={post.imageName}
                          alt={post.webinarName} width={300} height={180}
                        />
                      
                    </div>                            
                    </div>
                  </li>
                ))}
              </ul>
          </div>
        </section>
        {showVideo && 
        <div className='fixed inset-0 bg-[rgba(0,0,0,0.8)] z-[99] flex items-center justify-center' onClick={videoOff}>
            <div className='fixed bg-white left-0 mx-auto right-0 max-w-[800px] h-auto p-2 rounded-md'>
            <video controls width="100%" height="auto" id="video" autoPlay={isVideoPlaying}>
                <source src={showVideoLink} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            </div>
        </div>
        }
        
    </main>
  )
}
